export default {
  "HitPaw Online Audio Converter": "Konverter Audio Online HitPaw",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Konversi audio ke format MP3, AAC, FLAC, WMA, dan lainnya secara gratis.",
  'HitPaw Online Image Converter': 'Konverter Gambar Online HitPaw',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Konversi gambar ke JPG, PNG, BMP, TIFF dan format lain secara gratis.',
  'HitPaw Online Video Converter': 'HitPaw Kotak Alat Pengeditan Video Online',
  'Convert videos to any formats as your requirements.': 'Pilih alat yang paling sesuai untuk mengedit video Anda dalam langkah sederhana, tekan untuk mulai!',
  'Add More Files': 'Tambahkan Lebih Banyak File',
  'Convert to': 'Konversi ke',
  'Ready': 'Siap',
  'Converting': 'Mengkonversi',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Gambar',
  'Retry': 'Coba Lagi',
  'Download All': 'Unduh Semua',
  'Download Desktop': 'Unduh Desktop',
  'Continue Editing': 'Lanjutkan Mengedit',
  'Convert': 'Konversi',
  'Cut': 'Potong',
  'Speed': 'Kecepatan',
  'Crop & Rotate': 'Crop & Rotate',
  'Resize': 'Resize',
  'Extract': 'Ekstrak',
  'Add Music': 'Tambah Musik',
  'Subtitles': 'Subtitle',
  'Merge': 'Merge',
  'Watermark Remover': 'Penghilang Watermark',
  'Add Watermark': 'Tambahkan Watermark',
  'Please select a file to use': 'Silahkan pilih file untuk menggunakan {{work}}',
  'Batch Processing': 'Batch Processing',
};
